import { createReducer } from 'actionware';
import { createState } from 'stateware';
import { toggleAccountCreationModal } from './accountCreationActions';

const initialState = createState({
  showingAccountCreationModal: false,
  action: 'create'
});

export default createReducer(initialState)
.on(
  toggleAccountCreationModal,
  (state, action) => {
    const actionData = action === 'edit' ? 'edit' : 'create'
    return initialState.copy({
      showingAccountCreationModal: !state.showingAccountCreationModal,
      action: actionData
    })
  }
);
